'use strict';

/**
 * @ngdoc service
 * @name webAgro1App.MessagesService
 * @description
 * # MessagesService
 * Factory in the webAgro1App.
 */
// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('MessagesService', function($q) {
  const BUTTON_CONFIRM_TEXT = 'OK';
  const BUTTON_CANCEL_TEXT = 'Cancelar';

  return {
    alert: function(message) {
      bootbox.alert(message);
    },

    prompt: function(title, options) {
      const deferred = $q.defer();
      bootbox.prompt({
        title: title,
        callback: function(result) {
          if (result === null) {
            deferred.reject();
          } else {
            deferred.resolve(result);
          }
        },
        ...options
      });
      return deferred.promise;
    },

    confirm: function(message, buttons) {
      const deferred = $q.defer();
      bootbox.confirm({
        message: message || '',
        buttons: buttons || {
          cancel: { label: BUTTON_CANCEL_TEXT },
          confirm: { label: BUTTON_CONFIRM_TEXT }
        },
        callback: function(result) {
          if (result) {
            deferred.resolve();
          } else {
            deferred.reject();
          }
        }
      });

      return deferred.promise;
    },

    dialogCustom: function(title, message, btn) {
      const deferred = $q.defer();

      const getButtons = function(buttons) {
        const buttonsObject = {};
        const keys = Object.keys(buttons) || [];
        for (let i = 0; i <= keys.length-1; i++) {
          (function(index) {
            buttonsObject[index] = {
              label: 'Ok',
              className: 'btn-success',
              callback: function() {
                deferred.resolve(buttons[keys[index]]);
              },
              ...buttons[keys[index]]
            };
          }(i));
        }
        return buttonsObject;
      };
      bootbox.dialog({
        message: message,
        title: title,
        buttons: getButtons(btn),
        onEscape: function() {
          deferred.reject();
        }
      });
      return deferred.promise;
    }
  };
});
